<template>
<div>
  <div class="container form-container">
      <div class="row pb-3">
          <div class="col-12 col-md-4">
              <div class="clinical-trials-content">
                  <h2 :class="post_title_h_style">{{ post_title }}</h2>
                  <div>{{ post_description }}</div>
              </div>
          </div>
          <div class="col-12 col-md-8">
            <form id="event-search-form" class="vue-app">
                <div class="form-row">
                    <div class="col-12">
                        <strong class="h5">Filter Articles By:</strong>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="blogCheckbox" value="Blogs" v-model="form.blog">
                                <label class="form-check-label" for="blogCheckbox">Blogs</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="newsCheckbox" value="News" v-model="form.news">
                                <label class="form-check-label" for="newsCheckbox">News</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <startdate placeholder="Start Date" v-model="form.start_date" name="post_date" :clear-button="true" :typeable="true"></startdate>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <enddate placeholder="End Date" v-model="form.end_date" name="end_date" :clear-button="true" :typeable="true"></enddate>
                        </div>
                    </div>
                </div>
                <div class="form-row mb-3">
                    <div class="col-12">
                        <div class="form-group">
                            <multiselect
                                id="search-physician"
                                ref="search_physician"
                                v-model="form.physician"
                                :options="physicians"
                                :multiple="true"
                                placeholder="Physicians"
                                :close-on-select="false"
                                :clear-on-select="true"
                                selectLabel="Press enter or click to select"
                                deselectLabel="Press enter or click to remove"
                                label="text"
                                track-by="id"
                                :maxHeight="dropdownHeight"
                                @open="onMultiselectOpen"
                                @close="onMultiselectClose"
                            >
                            </multiselect>
                        </div>
                        <div class="form-group">
                            <multiselect
                                id="search-location"
                                ref="search_location"
                                v-model="form.location_id"
                                :options="locations"
                                :multiple="true"
                                placeholder="Locations"
                                :close-on-select="false"
                                :clear-on-select="true"
                                selectLabel="Press enter or click to select"
                                deselectLabel="Press enter or click to remove"
                                label="text"
                                track-by="id"
                                :maxHeight="dropdownHeight"
                                @open="onMultiselectOpen"
                                @close="onMultiselectClose"
                            >
                            </multiselect>
                        </div>
                    </div>
                </div>

                <div class="form-row pt-2">
                    <button type="submit" @click.prevent="searchNews(true)" class="btn btn-primary mx-1">Search</button>
                    <button type="submit" @click.prevent="resetForm()" class="btn btn-dark">Reset Form</button>
                </div>
            </form>
          </div>
      </div>
  </div>
  <div class="container-fluid clip-path-ellipse-concave-concave" id="news-featured-post">
      <div class="container py-3">
          <div class="row">
              <news-featured :featured_post="featured_post"></news-featured>
          </div>
      </div>
  </div>
  <div class="container-fluid" id="news-results-wrap">
    <div class="container py-3">
      <div class="row vue-search-results" id="news-results">
        <div class="col-12 pb-3">
            Showing {{ min_count }} - {{ count }} of {{ total_count }} results
        </div>
          <news-results v-for="post in news" :key="post['title']" :news="post"></news-results>
          <div class="col-12" v-bind:class="{'d-none': total_count || !initialized }">{{ no_results_message }}</div>
      </div>
    </div>
    <div class="container py-2" v-bind:class="{'d-none': has_more }">
      <div class="row justify-content-center">
        <button type="button" @click.prevent="showMoreCards()" class="btn btn-primary">Load More Results</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import ApiCalls from "../../api/apiServices"
import NewsResults from "../results/wf-news-results.vue"
import FeaturedPost from "../news-featured/wf-featured-post.vue"
import Helpers from "../../scripts/helpers"
import { mapMutations } from 'vuex'

export default {
    data() {
        return {
            post_title: '',
            post_title_h_style: 'h2',
            post_description: '',
            featured_id: '',
            form: {
                location_id: [],
                blog: false,
                news: false,
                start_date: null,
                end_date: null,
                physician: [],
            },
            news: '',
            locations: [],
            physicians: [],
            featured_post: '',
            dropdownHeight: 200,
            initialized: false,
            no_results_message: window.post_search ? window.post_search.no_results_message : 'No results found.',
        }
    },
    computed: {
        min_count() {
            return this.$store.state.results_count == 0 ? 0 : 1
        },
        has_more() {
            return this.$store.state.results_count <= this.$store.state.news_shown_count
        },
        newsResults() {
            return this.news
        },
        count() {
            return Math.min(this.$store.state.news_shown_count, this.$store.state.results_count)
        },
        total_count(){
            return this.$store.state.results_count
        }
    },
    methods: {
        ...mapMutations(
            ['incrementCount', 'resetCount', 'showMoreNews', 'resetNewsShownCount']
        ),
        searchNews(scroll = false){
            this.resetNewsCount(this)
            ApiCalls.getNews(this.form.blog, this.form.news, this.form.start_date, this.form.end_date, this.form.physician.map((a) => a.id), this.form.location_id.map((a) => a.id)).then((data) => {
                if(data != null) {
                    for (var post in data) {
                        this.incrementCount(this)
                    }
                    this.$set(this, 'news', data)
                    setTimeout( this.showCards, 400)
                }
                this.$set(this, 'initialized', true);
                if (scroll) {
                    document.querySelector('.vue-search-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
                }

            })
        },
        resetForm(){
            this.form = {
                location_id: [],
                blog: false,
                news: false,
                start_date: null,
                end_date: null,
                physician: []
            }
        },
        retrieveDropdowns(){
            this.getDropdownValues(window.locations).then((results) => {
                if( results != null ) {

                    Object.values(results).forEach(result => {

                    let text = result.text
                    let id = result.id
                    let location = {
                        text: text,
                        value: id,
                        id: id,
                        disabled: false,
                    }
                    this.locations.push(location)
                    })
                }
            }),
            this.getDropdownValues(window.physicians).then((results) => {
                if( results != null ) {
                    Object.values(results).forEach(result => {
                        let text = result.text
                        let id = result.id
                        let physician = {
                            text: text,
                            value: id,
                            id: id
                        }
                        this.physicians.push(physician)
                    })
                }
            })
        },
        getDropdownValues(type){
            return new Promise((resolve, reject) => {
                resolve(type)
            })
        },
        retrieveFeatured(){
            this.getDropdownValues(window.featured_post).then((data) => {
                if( data != null ) {
                    Object.values(data).forEach(result => {
                        this.featured_post = result
                    })
                }
            })
        },
        retrievePostInfo(){
            let postDataEl = document.querySelector('#post_data')
            let postID = postDataEl.dataset.id
            ApiCalls.getPostTitleAndDescription(postID).then((data) => {
                if(data != null){
                this.post_title = Helpers.decodeHTMLEntities(data.page_title)
                this.post_description = Helpers.decodeHTMLEntities(data.page_content)
                this.post_title_h_style = data.page_title_h_style ? data.page_title_h_style : 'h2'
                }
            })
        },
        showCards(){
            let cards = document.querySelectorAll('#news-results .card-wrap')
            let count = 0
            if(cards != null && cards.length > 0){
                [...cards].forEach((card) => {
                    if(count < this.$store.state.news_shown_count) {
                        if(!card.classList.contains('active')) {
                            card.classList.add('active')
                        }
                    } else {
                        card.classList.remove('active')
                    }
                    count++
                })
            } else {
                setTimeout( this.showCards, 400)
            }
        },
        showMoreCards(){
            this.showMoreNews(this)
            this.showCards()
        },
        resetNewsCount(){
            this.resetCount(this)
            this.resetNewsShownCount(this)
        },

        findSpacingTarget() {
            return this.$el.querySelector(".form-container")
        },
        findPositionTop(elem) {
            let offsetTop = 0;
            do {
                offsetTop += elem.offsetTop
            } while (elem = elem.offsetParent)
            return offsetTop;
        },

        onMultiselectOpen(id) {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                let dropdownField = this.$el.querySelector("#" + id).closest('.multiselect')
                let ddtop = this.findPositionTop(dropdownField) - this.findPositionTop(spacingTarget)
                spacingTarget.style.marginBottom = Math.max(0, (ddtop + dropdownField.offsetHeight + this.dropdownHeight) - spacingTarget.offsetHeight) + "px"
            }
        },

        onMultiselectClose() {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                spacingTarget.style.marginBottom = 0
            }
        },
    },
    mounted() {
        this.resetNewsCount();
        ["search_physician", "search_location"].forEach((item) => {
            this.$refs[item].$refs.search.setAttribute("autocomplete", "off");
        })
    },
    created() {
        this.searchNews()
        this.retrieveFeatured()
        this.retrievePostInfo()
        this.retrieveDropdowns()
    },
    components: {
        'startdate' : Datepicker,
        'enddate' : Datepicker,
        'news-results' : NewsResults,
        'news-featured' : FeaturedPost
    }
}
</script>